export default function StJosephAcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "St. Joseph Main Post Office",
      address: "502 Francis St, St. Joseph, MO 64501",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      phone: "(816) 390-3232",
      notes: "Primary passport acceptance facility in Buchanan County. Appointment recommended — walk-in availability varies by season. Passport photos available on-site.",
    },
    {
      name: "St. Joseph Frederick Ave Post Office",
      address: "4217 Frederick Ave, St. Joseph, MO 64506",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      phone: "(816) 279-3631",
      notes: "North St. Joseph option. Passport acceptance by appointment. Call ahead to confirm current availability — this location can be less busy than the main office during peak season.",
    },
    {
      name: "Savannah Post Office",
      address: "515 W Main St, Savannah, MO 64485",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      phone: "(816) 324-5431",
      notes: "Serving Andrew County and northern Buchanan County residents. Appointment recommended. Limited passport photo availability — confirm before visiting.",
    },
    {
      name: "Maryville Post Office",
      address: "318 N Market St, Maryville, MO 64468",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      phone: "(660) 582-8524",
      notes: "Serving Nodaway County and Northwest Missouri State University area. Convenient for travelers in the northern I-29 corridor.",
    },
  ];

  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit a New Passport in the St. Joseph Area
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants and minors must visit an acceptance clerk in person. St. Joseph-area residents can use these facilities — most travelers then ship their sealed envelope directly to Fast Passport Center for expedited processing without driving to Kansas City.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <p className="text-gray-500 text-xs mt-0.5">{f.address}</p>
                </div>
              </div>
              <div className="space-y-1.5 text-xs text-gray-500 ml-12">
                <p><i className="ri-time-line text-[#F6C344] mr-1"></i>{f.hours}</p>
                <p><i className="ri-phone-line text-[#F6C344] mr-1"></i>{f.phone}</p>
              </div>
              <div className="mt-3 ml-12 bg-white rounded-md p-3 border border-gray-200">
                <p className="text-gray-500 text-xs leading-relaxed">{f.notes}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base mb-1">How This Works With Fast Passport Center</p>
            <p className="text-white/60 text-sm leading-relaxed">
              Visit the acceptance clerk at your nearest St. Joseph-area post office, then ship your sealed application overnight to Fast Passport Center. We handle the expedited submission — no appointment race in Kansas City required.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Start Now <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}